/**
 * Class to generate radius on route detail.
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.StopRadius = function (map, routeId) {

    this.drawPolygon = function (geofence, options, routeDetailType) {

        var latLngs = [];
        var polygon;

        for (var x in geofence) {
            if (geofence.hasOwnProperty(x)) {
                latLngs.push([geofence[x].latitude, geofence[x].longitude]);
            }
        }

        polygon = new L.Polygon(latLngs, options);
        polygon.kindParent = "RouteDetail_" + routeId;
        polygon.routeDetailType = routeDetailType;

        map.addLayer(polygon);
        polygon.bringToBack();

    };

    this.drawGeofence = function (stop) {
        var geofence        = stop.location.geofence,
            routeDetailType = "radiusRouteDetail_" + stop.id;

        this.drawPolygon(geofence, {
            color: 'blue',
            weight: 3
        }, routeDetailType);
    };

    this.drawExpandedGeofence = function (stop) {
        var geofence        = stop.location.expandedGeofence,
            routeDetailType = "expandedRadiusRouteDetail_" + stop.id;

        this.drawPolygon(geofence, {
            color: 'blue',
            fillOpacity: 0.15,
            opacity: 0.4,
            dashArray: "5, 3",
            lineCap: "butt",
            weight: 2
        }, routeDetailType);
    };

    this.drawCircle = function (latlong, options, radius, routeDetailType) {
        var circle = new L.Circle(L.latLng(latlong.latitude, latlong.longitude), radius, options);

        circle.kindParent = "RouteDetail_" + routeId;
        circle.routeDetailType = routeDetailType;

        map.addLayer(circle);
    };

    this.drawRadius = function (stop, radius) {
        const latlong = {
            latitude: stop.latitude,
            longitude: stop.longitude
        };

        const routeDetailType = "radiusRouteDetail_" + stop.id;

        this.drawCircle(latlong, {
            color: '#60AFF4',
            opacity: 1,
            fillColor: '#60AFF4',
            fillOpacity: 0.8,
            weight: 2
        }, radius, routeDetailType);

    };

    this.drawExpandedRadius = function (stop) {
        var deliveryRadius = stop.location.expandedDeliveryRadius;
        var radius = new L.Circle(L.latLng(stop.latitude, stop.longitude), deliveryRadius, {
            color: '#60AFF4',
            fillColor: '#60AFF4',
            fillOpacity: 0.4,
            opacity: 0.4,
            dashArray: "5, 3",
            lineCap: "butt",
            weight: 2
        });

        radius.kindParent = "RouteDetail_" + routeId;
        radius.routeDetailType = "expandedRadiusRouteDetail_" + stop.id;

        map.addLayer(radius);

    };

    this.checkDeliveryRadiusInLocation = function (stop) {

        if (stop.latitude && stop.longitude) {
            if (stop.location?.geofence) {
                this.drawGeofence(stop);
            } else if (stop.location?.deliveryRadius) {
                this.drawRadius(stop, stop.location.deliveryRadius);
            } else if (Monet.Session.Configurations.organizationRadius){
                this.drawRadius(stop, Monet.Session.Configurations.organizationRadius);
            }
        }

    };

    this.checkDeliveryExpandedRadiusInLocation = function (stop) {

        if (stop.latitude && stop.longitude) {
            if (stop.location?.expandedGeofence) {
                this.drawExpandedGeofence(stop);
            } else if (stop.location?.expandedDeliveryRadius) {
                this.drawExpandedRadius(stop);
            }
        }

    };

    this.drawRadiusFromStop = function () {

        var sourceData = Monet.Session.RouteDetail.screensList[routeId];
        var stops = sourceData.markerStops;

        this.removePositionRadius();

        for (var i = 0, j = stops.size(); i < j; i++) {
            var stop = stops.at(i).get('stop');
            this.checkDeliveryRadiusInLocation(stop);
        }

    };

    this.drawExpandedRadiusFromStop = function () {

        var sourceData = Monet.Session.RouteDetail.screensList[routeId];
        var stops = sourceData.markerStops;

        this.removePositionExpandedRadius();

        for (var i = 0, j = stops.size(); i < j; i++) {
            var stop = stops.at(i).get('stop');
            this.checkDeliveryExpandedRadiusInLocation(stop);
        }

    };

    this.removePositionRadius = function () {

        var sourceData = Monet.Session.RouteDetail.screensList[routeId];
        var idStop = null;
        var map = sourceData.map;
        var layers = map._layers;
        var stops = sourceData.markerStops;
        var removeLayer = function (element) {

            idStop = element.get('stop').id;

            if (this.routeDetailType === "radiusRouteDetail_" + idStop) {
                map.removeLayer(this);
            }
        };

        for (var key in layers) {

            stops.models.forEach(removeLayer, layers[key]);

        }

    };


    this.removePositionExpandedRadius = function () {

        var sourceData = Monet.Session.RouteDetail.screensList[routeId];
        var idStop = null;
        var map = sourceData.map;
        var layers = map._layers;
        var stops = sourceData.markerStops;
        var removeLayer = function (element) {

            idStop = element.get('stop').id;

            if (this.routeDetailType === "expandedRadiusRouteDetail_" + idStop) {
                map.removeLayer(this);
            }
        };

        for (var key in layers) {

            stops.models.forEach(removeLayer, layers[key]);

        }

    };

};
